<template lang="pug">
el-dialog(v-dialogDrag title="复制业务模型" :visible.sync="dataDialog" width="500px" :before-close="handleClose")
  el-form.form(ref="ruleForm", :rules="rules", :model="copyForm", label-position="right", label-width="130px", size="small")
    el-form-item(label="新内部名称", prop="tableName")
      el-input(v-model="copyForm.tableName")
      span 提示： 表名必须以z_开头，必须唯一且不能重复
    el-form-item(label="新业务模型名称", prop="businessName")
      el-input(v-model="copyForm.businessName", placeholder="请输入中文名称")
    el-form-item(label="描述", prop="tableDesc")
      el-input(v-model="copyForm.tableDesc", type="textarea", placeholder="请输入中文名称")
  div(slot="footer")
      el-button(@click="handleClose" size="small") 取 消
      el-button(type="primary" @click="onSubmit" size="small") 确 定
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
const copyEditData = () => ({
  tableName: "z_",
  businessName: "",
  tableDesc: ""
});
export default {
  data () {
    return {
      dataDialog: false,
      rules: {
        tableName: [{ required: true, message: "请输入内部名称", trigger: "blur" }],
        businessName: [{ required: true, message: "请输入业务模型名称", trigger: "blur" }]
      },
      sourceTableName: "",
      groupId: "",
      copyForm: copyEditData()
    };
  },
  computed: {
    cloneParams() {
      return {
        ...this.copyForm,
        sourceTableName: this.sourceTableName,
        groupId: this.groupId
      };
    }
  },
  methods: {
    openDialog(row) {
      this.sourceTableName = row.tableName;
      this.groupId = row.groupId;
      this.copyForm = copyEditData();
      this.dataDialog = true;
    },
    async onSubmit() {
      await this.$refs.ruleForm.validate();
      await this.$confirm("是否复制此业务模型?", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      });
      try {
        await metadataService.cloneModel(this.cloneParams);
        this.$success("添加成功!");
        this.$emit("initTree");
        this.copyForm = copyEditData();
        this.dataDialog = false;
      } catch (error) {
        console.log(error);
        this.dataDialog = false;
      }
    },
    handleClose() {
      this.copyForm = copyEditData();
      this.dataDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
